export {
    DEBOUNCED_CONFIG_KEYS,
    DEBOUNCE_MS,
    DEFAULT_SECTION_OPEN_STATE,
    DEFAULT_SPRAY_SETTINGS,
    SECTION_ADVANCED,
    SECTION_COVERAGE,
    SECTION_SPRAY
} from 'pages/ApplicationDetailsPage/components/FlightPlannerPanel/constants';

export const REPLAN_POLL_INTERVAL_MS = 20;

export const REPLAN_POLL_TIMEOUT_MS = 2000;

export const SQM_PER_HECTARE = 10_000;
